<template>
  <div class="content-box">
    <div class="search-good-items">
      <div
        class="search-good-item"
        :class="{active:index === tabActiveIndex}"
        v-for="(tab,index) in tabName"
        :key="index"
        @mouseenter="handleSearchGoodItemActive(index)"
      >{{tab}}</div>
    </div>
    <div class="search-good-content">
      <div v-if="tabActiveIndex ===0">
        <h3>住宿销量排行榜</h3>
        <ul class="rank">
          <li class="top3" @click="showGood(555)">
            <span class="top3 rank-index">1</span>
            <img
              src="http://test.00800.com.cn/data/upload/2017/1108/17/5a02d5496434953a6481.jpg"
              style="height:45px;width:60px;"
            />
            二人入格
          </li>
          <li class="top3" @click="showGood(561)">
            <span class="top3 rank-index">2</span>
            <img
              src="http://test.00800.com.cn/data/upload/2017/0818/16/5996ab431d0da70c8d1b.jpg"
              style="height:45px;width:60px;"
            />上房
          </li>
          <li class="top3" @click="showGood(560)">
            <span class="top3 rank-index">3</span>
            <img
              src="http://test.00800.com.cn/data/upload/2017/0818/16/5996ab06145edc68fae3.jpg"
              style="height:45px;width:60px;"
            />唐房
          </li>
        </ul>
      </div>
      <div v-if="tabActiveIndex ===1">
        <h3>套餐销量排行榜</h3>
        <ul class="rank">
          <li class="top3" @click="showGood(465)">
            <span class="top3 rank-index">1</span>
            <img
              src="http://test.00800.com.cn/data/upload/2017/0818/13/59968063bda40be37f90.jpg"
              style="height:45px;width:60px;"
            />大餐庙会二人入格套票
          </li>
          <li class="top3" @click="showGood(470)">
            <span class="top3 rank-index">2</span>
            <img
              src="http://test.00800.com.cn/data/upload/2017/0818/13/599682246f4f4c0893bd.jpg"
              style="height:45px;width:60px;"
            />大餐庙会2人唐房套票
          </li>
          <li class="top3" @click="showGood(471)">
            <span class="top3 rank-index">3</span>
            <img
              src="http://test.00800.com.cn/data/upload/2017/0818/14/5996847c95167521fb7d.jpg"
              style="height:45px;width:60px;"
            />大餐庙会2人上房套票
          </li>
        </ul>
      </div>
      <div v-if="tabActiveIndex ===2">
        <h3>门票销量排行榜</h3>
        <ul class="rank">
          <li class="top3" @click="showGood(551)">
            <span class="top3 rank-index">1</span>
            <img
              src="http://test.00800.com.cn/data/upload/2017/0818/16/5996a87746056df2c74b.jpg"
              style="height:45px;width:60px;"
            />(住店专享)大餐庙会
          </li>
          <li class="top3" @click="showGood(552)">
            <span class="top3 rank-index">2</span>
            <img
              src="http://test.00800.com.cn/data/upload/2018/0608/12/5b1a04547d42b0e5c86a.jpg"
              style="height:45px;width:60px;"
            />温泉票
          </li>
          <li class="top3" @click="showGood(1255)">
            <span class="top3 rank-index">3</span>
            <img
              src="http://test.00800.com.cn/data/upload/2019/0526/18/5cea67587ba1551f26ce.jpg"
              style="height:45px;width:60px;"
            />大餐庙会餐劵
          </li>
        </ul>
      </div>
    </div>
    <!-- <md-dialog :md-active.sync="showDialog" style="width:70%;height:97vh;max-height:100%;">
      <iframe
        :src="`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=goods_detail&no=${detialNo}`"
        style="height:100%"
      ></iframe>
    </md-dialog>-->
    <el-dialog :visible.sync="showDialog" custom-class="dialogClass" :append-to-body="true">
      <iframe
        :src="`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=goods_detail&no=${detialNo}`"
        style="height:100%;width:100%"
      ></iframe>
    </el-dialog>
  
  </div>
</template>

<script>

export default {
  name: "TabContent",
  data() {
    return {
      tabName: ["住宿", "套餐", "门票"],
      tabActiveIndex: 0,
      showDialog: false,
      detialNo: 0
    };
  },
  methods: {
    isPath(path) {
      return this.$route.path === path;
    },
    handleSearchGoodItemActive(index) {
      this.tabActiveIndex = index;
    },
    showGood(no) {
      this.detialNo = no;
      this.showDialog = true;
    }
  }
};
</script>
<style lang="scss" scoped>

.rank {
  list-style: none;
  margin: 5px 0;
  padding: 0 20px;
  li {
    color: #999;
    cursor: pointer;
    display: flex;
    overflow: hidden;
    text-align: left;
    line-height: 35px;
    font-size: 16px;
    &.top3 {
      color: #ef4238;
    }
  }
  .top3 {
    color: #ef4238;
    font-size: 16px;
    vertical-align: top;
  }
  .rank-index {
    width: 20px;
    margin: 15px 0;
    font-style: italic;
  }
}
.content-box {
  height: 312px;
  display: flex;
  background: #fff;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  .search-good-items {
    height: 100%;
    width: 75px;
    background: #f3f3f3;
    .search-good-item {
      position: relative;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #e1e1e1;
      font-size: 12px;
      text-align: center;
      cursor: pointer;
      &.active {
        background: #fff;
        border-left: 3px solid #eeca00;
        color: #eeca00;
      }
    }
  }
  .search-good-content {
    width: 100%;
  }
}
</style>
